import cleanDeep from 'clean-deep';
import { API, graphqlOperation } from 'aws-amplify';

import {
  deleteMeeting,
  createMeeting,
  updateMeeting,
} from '../graphql/mutations';

import {
  getMeetingByCompany,
  getMeetingsByTeamId,
  getMeetingsByUserId,
} from '../graphql/queries';

export const createMeetingRecord = (params) => API.graphql(
  graphqlOperation(createMeeting, { input: cleanDeep(params) }),
);

export const updateMeetingRecord = (params) => API.graphql(
  graphqlOperation(updateMeeting, { input: cleanDeep(params) }),
);

export const deleteMeetingRecord = (params) => API.graphql(
  graphqlOperation(deleteMeeting, { input: cleanDeep(params) }),
);

export const getMeetingRecordsByCompany = (companyId) => API.graphql(
  graphqlOperation(getMeetingByCompany, { companyId }),
);

export const getMeetingsRecordsByTeamId = (teamId) => API.graphql(
  graphqlOperation(getMeetingsByTeamId, { teamId }),
);

export const getMeetingsRecordsByUserId = (createdBy) => API.graphql(
  graphqlOperation(getMeetingsByUserId, { createdBy }),
);
